module.exports = __webpack_public_path__ + "img/transportation_icon.3bbbc27e.svg";